///wrap-with-provider.js


import React from "react"
import createStore from "./src/state/createStore"
import { Provider } from "react-redux"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowLeft, faArrowRight, faClock, faStopwatch, faSearch, faTimes, faCalendarAlt, faMapMarked } from '@fortawesome/free-solid-svg-icons'
import { getProducts, getRecipes, getEvents } from './src/state/actions'

export default ({ element }) => {
    const store = createStore()
    library.add(faArrowLeft, faArrowRight, faClock, faStopwatch, faSearch, faTimes, faCalendarAlt, faMapMarked)
    // Instantiating store in `wrapRootElement` handler ensures:
    //  - there is fresh store for each SSR page
    //  - it will be called only once in browser, when React mounts
    store.dispatch(getRecipes())
    store.dispatch(getProducts())
    store.dispatch(getEvents())

    return <Provider store={store}>{element}</Provider>
}